@if (isReady && formGroup()) {
  <div class="field">
    <ng-content></ng-content>
    <div class="left">
      <div class="one">
        <div class="form-field-name">
          <app-text [formGroup]="formGroup()!" [model]="field().value.name" [meta]="metaName" [readonly]="field().value.readonly"></app-text>
        </div>
        <div class="form-field-type">
          <app-type [formGroup]="formGroup()!" [model]="field().value.typeId" [meta]="metaType" [readonly]="field().value.readonly"></app-type>
        </div>
      </div>
      <div class="two">
        <div class="form-field-info">
          <app-text [formGroup]="formGroup()!" [model]="field().value.info" [meta]="metaInfo" [readonly]="field().value.readonly"></app-text>
        </div>
        <div class="form-field-mandatory">
          <app-checkbox [formGroup]="formGroup()!" [model]="field().value.mandatory" [meta]="metaMandatory" [readonly]="field().value.readonly"></app-checkbox>
        </div>
      </div>
      <div class="three" [hidden]="hideMeta">
        <app-textarea [formGroup]="formGroup()!" [model]="field().value.meta" [meta]="metaMeta" [readonly]="field().value.readonly"></app-textarea>
      </div>
      @if (tagControl()) {
        <input type="hidden" [formControl]="tagControl()!">
      }
    </div>
    <div class="right">
      <button type="button" matPrefix class="button" (click)="onDelete(field)" [disabled]="field().value.readonly"><mat-icon>delete</mat-icon></button>
      <button type="button" matPrefix class="button" (click)="onMeta()">@if (hideMeta) {
        <mat-icon>expand_more</mat-icon>
        }@if (!hideMeta) {
        <mat-icon>expand_less</mat-icon>
      }</button>
    </div>
  </div>
}
